import { AuthHttp } from 'angular2-jwt';
import { Injectable } from '@angular/core';
// import { Http } from '@angular/http';

@Injectable()
export class PaymentService {
  // private http: Http,
  constructor(private authHttp: AuthHttp) { }

  initPayment(paymentInfo:any){
    return this.authHttp.post("/api/payment", paymentInfo).map(res => {     
      let value = "";
      if (res.status == 200){
          value = res.json()
      }
      return {'status':res.status, 'value': value}
    });
  }

  CreatePaymentLink(paymentMetaData:any){
    return this.authHttp.post("/api/payment/link", paymentMetaData).map( (res:any) =>{
        let value:any ;
        if (res.status == 200){
          value = res.json()
        }
        return {'status': res.status, 'value': value}
      
    })
  }

  CheckPaymentLink(data: any){
    return this.authHttp.post("/api/payment/pay/"+data,null).map( res =>{
      
      
      let value = "";
      if (res.status == 200){
          value = res.json()
      }
      return {'status':res.status, 'value': value}

    })
  }
  
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./ClientApp/app/Services/payment.service.ts